module.exports = __webpack_public_path__ + "img/logo-github.5fe41609.svg";